/**
 * Presentation flag: hides every "this is a demo" tell — the demo banner, the
 * per-pane "Demo" badges, the connector-status pills and the DEV pill — even
 * though the underlying data is still fixtures. For customer-facing mockups and
 * screenshots that should read as a finished product.
 *
 * Read lazily (a function, not a module constant) so tests can stub the env.
 */
export function hideDemoBadges(): boolean {
  const value = import.meta.env.VITE_HIDE_DEMO_BADGES;
  return value === '1' || value === 'true';
}
